import "./ForgotPasswordComponent.scss";
import React, {useCallback} from "react";
import * as Yup from "yup";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import commonService from "../../../shared/services/common.service";
import FormikInputComponent from "../../../shared/components/core/formik-input/FormikInputComponent";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import {useLocation, useNavigate} from "react-router-dom";
import {ArrowBack} from "@mui/icons-material";
import {CommonService} from "../../../shared/services";

interface ForgotPasswordComponentProps {

}

const forgotPasswordFormValidationSchema = Yup.object({
    emailId: Yup.string()
        .email("Please enter a valid Email ID")
        .matches(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, "Enter a valid Email ID")
        .required("Email ID is required"),
});

const initialValues = {
    emailId: "",
}
const ForgotPasswordComponent = (props: ForgotPasswordComponentProps) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleNavigation = useCallback((route: string) => {
        let returnUrl = CommonService._routeConfig.Dashboard();
        const query = CommonService.parseQueryString(location.search);
        if (Object.keys(query).includes('returnUrl')) {
            returnUrl = query.returnUrl;
        }
        navigate(route + `?returnUrl=${returnUrl}`);
    }, [location, navigate]);

    const onFormSubmit = useCallback((values: typeof initialValues, {setSubmitting, setErrors}: FormikHelpers<any>) => {
        setSubmitting(true);
        const payload = {
            ...values,
            emailId: values?.emailId?.toLowerCase(),
        };
        commonService._account.sendForgotPasswordEmail(payload)
            .then((response: any) => {
                setSubmitting(false);
                handleNavigation(commonService._routeConfig.CheckYourEmailRoute(payload.emailId));
                commonService._alert.showToast("Email sent successfully", "success")
                // onSuccessfulSendingLink ?onSuccessfulSendingLink(payload.emailId) : handleNavigation(commonService._routeConfig.SendEmailRoute(payload.emailId))
            })
            .catch((error: any) => {
                commonService.handleErrors(setErrors, error);
                setErrors(error);
                setSubmitting(false);
            })
    }, [handleNavigation]);

    return (
        <div className={'forgot-password-component screen width-100'}>
            <div className="forgot-password-title auth-form-title">
                Forgot Password?
            </div>
            <div className="forgot-password-description auth-form-description">
                No worries! Please enter the Email ID associated with your account and we’ll send you a link to reset
                password.
            </div>
            <Formik
                validationSchema={forgotPasswordFormValidationSchema}
                initialValues={initialValues}
                validateOnChange={true}
                validateOnBlur={true}
                enableReinitialize={true}
                onSubmit={onFormSubmit}
            >
                {({values, validateForm, isValid, isSubmitting}) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    return (
                        <Form noValidate={true}>
                            <div className="t-form-controls forgot-password-form-controls  pdd-top-10">
                                <Field name={'emailId'} className="t-form-control">
                                    {
                                        (field: FieldProps) => (
                                            <FormikInputComponent
                                                label={'Email ID'}
                                                placeholder={'Enter your Email ID'}
                                                type={"email"}
                                                required={true}
                                                formikField={field}
                                                fullWidth={true}
                                                id={"email_input"}
                                            />
                                        )
                                    }
                                </Field>
                            </div>
                            <div className="t-form-actions">
                                <ButtonComponent
                                    isLoading={isSubmitting}
                                    variant={"contained"}
                                    color={"primary"}
                                    disabled={isSubmitting || !isValid}
                                    type={"submit"}
                                    size={"large"}
                                    fullWidth={true}
                                    id={"login_btn"}
                                >
                                    Submit
                                </ButtonComponent>
                                <ButtonComponent
                                    // isLoading={isLoggingIn}
                                    variant={"text"}
                                    startIcon={<ArrowBack/>}
                                    type={"button"}
                                    color={"primary"}
                                    fullWidth={true}
                                    size={"large"}
                                    id={"login_btn"}
                                    className={'mrg-top-20'}
                                    handleClick={() => {
                                        // onLoginClick ? onLoginClick() :
                                        handleNavigation(commonService._routeConfig.LoginRoute())
                                    }}
                                >
                                    Back to login
                                </ButtonComponent>
                            </div>
                        </Form>
                    )
                }}
            </Formik>

        </div>
    );

};

export default ForgotPasswordComponent;
